import { render, staticRenderFns } from "./EditLoyaltyPrograms.vue?vue&type=template&id=53b31858"
import script from "./EditLoyaltyPrograms.vue?vue&type=script&lang=ts"
export * from "./EditLoyaltyPrograms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports